import { createAuthClient } from 'better-auth/react';
import { API_URL } from '@/api/api.utils';

export const authClient = createAuthClient({
  baseURL: API_URL,
  basePath: '/auth',
  plugins: [],
});

export const { useSession, signIn, signOut } = authClient;
